import * as React from 'react';

function SvgOpenOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M18.667 9.94v9.852a2.224 2.224 0 01-2.224 2.224H4.224A2.224 2.224 0 012 19.792V7.52c0-1.228.996-2.224 2.224-2.224h8.887" }),
        React.createElement("path", { fill: "currentColor", d: "M9.763 13.08a.8.8 0 001.132 1.132l-1.132-1.131zM22.458 2.65a.8.8 0 00-1.131-1.132l1.131 1.132zM10.895 14.212L22.458 2.65l-1.131-1.132L9.763 13.081l1.132 1.131z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M16.136 1.983H22V7.84" })));
}

export default SvgOpenOutline;
